import { useMemo } from 'react';
import pluralize from 'pluralize';

export const getCampaignsHeader = (campaignCount = 0) =>
  `${campaignCount?.toLocaleString()} ${pluralize('campaign', campaignCount ?? 0)}`;

export const getCampaignsColumns = ({ campaignCount = 0 }) => [
  {
    Header: getCampaignsHeader(campaignCount),
    accessor: 'name',
    width: 448,
    disableSortBy: true,
    lockPosition: 'left',
    pinned: 'left',
    hideOnTableColumn: true,
    cellRenderer: 'campaignRenderer',
    suppressMovable: true,
    valueFormatter: ({ data: { original } }) => original.name,
    headerStyle: { paddingLeft: '8px' },
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 224,
    disableSortBy: true,
    hideOnTableColumn: true,
    cellRenderer: 'campaignStatusRenderer',
    valueFormatter: ({ data: { original } }) => original.status,
  },
  {
    Header: 'Emailed candidates',
    accessor: 'emailedCandidates',
    width: 224,
    disableSortBy: true,
    hideOnTableColumn: true,
    cellRenderer: 'tableRow',
    valueFormatter: ({ data: { original } }) => `${original.candidatesEmailedCount}`,
  },
  {
    Header: 'Candidates who clicked "Apply"',
    accessor: 'candidatesClickedApply',
    flex: 1,
    hideOnTableColumn: true,
    cellRenderer: 'tableRow',
    disableSortBy: true,
    valueFormatter: ({ data: { original } }) => original.candidatesClickedCount || 0,
  },
];

export const useCampaignsTableRows = ({ campaigns }) =>
  useMemo(
    () =>
      campaigns.map((campaign) => ({
        id: campaign.id,
        index: campaign.index,
        name: campaign.campaignName,
        status: campaign.status,
        emailedCandidates: campaign.candidatesEmailedCount,
        candidatesClickedApply: campaign.candidatesClickedCount,
        original: campaign,
      })),
    [campaigns],
  );
